import React, {Fragment, Suspense, useEffect, useRef} from 'react';
import './assets/legacy.css';
import {getMappedFormName, getServerDomainURL, getSessionValue, getURLParameters, randstr} from "../../Common/Appcommon";
import Common from "../../Common/Common";

const LegacyFrame = (props) => {
    let iframe = null;
    let {formname, customClass, withHeader, pageTitle, isPageTitleNeeded, customFrameClass, formId,iurl} = props;
    const ref = useRef();
    useEffect(() => {
        // Access the iframe element by ID and do something with it
        iframe = document.getElementById('legacy_iframe');
        let clonedIframe = iframe.cloneNode(true);
        clonedIframe.id = "cloned_iframe";
        let iframesrc = clonedIframe.src;
        let selectMenu = window.location.hash;
        let params = getURLParameters(selectMenu);
        let newFormname = "";
        let formLabel = "";
        if(params['form'] !== undefined){
            formLabel = params['form'];
            formLabel = formLabel.replaceAll("_", " ");
            newFormname = getMappedFormName(formLabel);
        }
        if(params['formid'] !== undefined){
            formId = params['formid'];
        }
        if(newFormname === undefined || newFormname === ""){
            newFormname = formname;
        }
        //let iframesrcArr = iframesrc.split('=');
        //if(iframesrcArr[1] !== newFormname){
        //    let newSrc = iframesrcArr[0]+"="+newFormname+"&source=wacrm";
            //clonedIframe.src = newSrc;
        //}
        let appUrl = getServerDomainURL();

        if(appUrl.indexOf("localhost")){
            appUrl = appUrl.replace(":5000","");
        }
        let appid = getSessionValue('appid');

        let htmlPage = `wa_${appid}.html`;

        let iframeVersion = process.env.REACT_APP_IFRAME_VERSION;
        if(appid.startsWith('4_')){
            htmlPage = `wacrm_`+iframeVersion+`.html`;
        }

        let fieldUrl = appUrl+"/"+htmlPage+"#f="+newFormname+"&source=wacrm";

        if(formId !== undefined && formId !== ""){
            fieldUrl = appUrl+"/"+htmlPage+"#f="+newFormname+"&id="+formId+"&source=wacrm";
        }
        if(formname === "notifications"){
            fieldUrl = fieldUrl + "&notificationtype="+props.notificationType;
        }
        if(props.templateType !== undefined && props.templateType != ""){
            fieldUrl = fieldUrl + "&templatetype="+props.templateType;
        }
        if(props.integratedType !== undefined && props.integratedType !== ""){
            fieldUrl = fieldUrl + "&integratedtype="+props.integratedType;
        }
        if(props.webhookid !== undefined && props.webhookid !== ""){
            fieldUrl = fieldUrl + "&webhookid="+props.webhookid;
        }
        fieldUrl = fieldUrl + "&version="+iframeVersion;
        if (iurl && iurl.trim() !== "") { // External URL 
        const hasProtocol = iurl.startsWith("http://") || iurl.startsWith("https://"); 
        fieldUrl = hasProtocol ? iurl : "https://" + iurl;
        }
        clonedIframe.src = fieldUrl;
        clonedIframe.allow = "microphone *;";
        ref.current.appendChild(clonedIframe);
      }, []);

    /*let appUrl = getServerDomainURL();

    if(appUrl.indexOf("localhost")){
        appUrl = appUrl.replace(":5000","");
    }
    let appid = getSessionValue('appid');

    let htmlPage = `wa_${appid}.html`;

    if(appid.startsWith('4_')){
        htmlPage = `wacrm.html`;
    }

    let fieldUrl = appUrl+"/"+htmlPage+"#f="+formname+"&source=wacrm";

    if(formId !== undefined && formId !== ""){
        fieldUrl = appUrl+"/"+htmlPage+"#f="+formname+"&id="+formId+"&source=wacrm";
    }

    if(formname === "notifications"){
        fieldUrl = fieldUrl + "&notificationtype="+props.notificationType;
    }
    if(props.templateType !== undefined && props.templateType != ""){
        fieldUrl = fieldUrl + "&templatetype="+props.templateType;
    }*/
    isPageTitleNeeded = false;//isPageTitleNeeded === undefined ? true : isPageTitleNeeded;
    if(withHeader){
        return (
            <Common pageTitle={pageTitle} showLoader={false}  mainContent={
                <Fragment>
                    <div  ref={ ref } className={`legacy-settings-container legacy-with-header ${customClass}`}>
                        {isPageTitleNeeded && <h3>{pageTitle}</h3> }
                        
                    </div>
                </Fragment>
            }/>
        )
    }
    return (
        <div  ref={ ref } className={`legacy-settings-container legacy-without-header ${customClass}`}>
            {isPageTitleNeeded && <h3>{pageTitle}</h3>}

            
        </div>
    );
}

export default LegacyFrame;
